// CDN assets (swap to your own)
import { env } from "@/lib/env";


export const SIDE_IMAGE =
  `${env.ASSETS_BASE_URL}/assets/website-images/login/admin-login.png`;
export const LOGO =
  `${env.ASSETS_BASE_URL}/assets/branding/logo.png`;
export const PLANE_LOADER = `${env.ASSETS_BASE_URL}/assets/branding/page-loader.gif`;
